/* Zwergerl Shop — Sticky Kaufleiste auf der Produktseite (nur Mobil).
   Loest das gemessene Problem, dass "In den Warenkorb legen" bei 375x812 erst
   nach 0,37 Bildschirmen Scrollen sichtbar wird.

   Bewusst kein eigenes Formular: Der Klick loest den ECHTEN Button aus. So
   bleiben Varianten-Logik, Mengen und alle App-Hooks von Dawn intakt. */
(function () {
  // Nur auf echten Produktseiten. Die Pruefung laeuft ueber die URL, weil
  // Dawn keine template-product-Klasse am body setzt UND weil ein
  // form[action*="/cart/add"] auch auf der Startseite vorkommt — durch
  // Quick-Add-Buttons und hervorgehobene Produkte. Genau daran ist die
  // Leiste am 27.08.2026 faelschlich auf der Startseite erschienen.
  if (!/\/products\//.test(window.location.pathname)) return;

  // Und nur das Formular der Hauptsektion, nicht irgendeins auf der Seite.
  const hauptbereich = document.querySelector('.product__info-container') || document;

  const echterButton = hauptbereich.querySelector(
    'product-form [name="add"], .product-form__submit, form[action*="/cart/add"] [type="submit"]'
  );
  if (!echterButton) return;

  const titel = (hauptbereich.querySelector('.product__title h1, .product__title') || {}).textContent || '';
  const preisEl = hauptbereich.querySelector('.price__container .price-item--sale, .price__regular .price-item, .price-item');
  const preis = (preisEl ? preisEl.textContent : '').trim();

  const leiste = document.createElement('div');
  leiste.className = 'zw-sticky-cart';
  leiste.innerHTML =
    '<span class="zw-sticky-cart__info">' +
      '<span class="zw-sticky-cart__title"></span>' +
      '<span class="zw-sticky-cart__price"></span>' +
    '</span>' +
    '<button type="button" class="zw-sticky-cart__button"></button>';

  leiste.querySelector('.zw-sticky-cart__title').textContent = titel.trim().slice(0, 60);
  leiste.querySelector('.zw-sticky-cart__price').textContent = preis;

  const knopf = leiste.querySelector('.zw-sticky-cart__button');
  knopf.textContent = (echterButton.textContent || 'In den Warenkorb').trim();
  knopf.addEventListener('click', () => echterButton.click());

  document.body.appendChild(leiste);
  document.body.classList.add('zw-has-sticky-cart');

  // Leiste zeigen, solange der echte Button NICHT im Blickfeld ist.
  // Bewusst per scroll/resize statt IntersectionObserver: Der Observer liefert
  // in Umgebungen ohne Frame-Compositing (Hintergrundtabs, headless) keine
  // Callbacks. getBoundingClientRect misst immer.
  const pruefen = () => {
    const r = echterButton.getBoundingClientRect();
    const sichtbar = r.bottom > 80 && r.top < window.innerHeight - 80;
    leiste.classList.toggle('is-visible', !sichtbar);
  };
  // Zeitbasiert gedrosselt statt requestAnimationFrame: rAF setzt gerenderte
  // Frames voraus und steht in Hintergrundtabs still — setTimeout laeuft immer.
  let wartet = false;
  const angestossen = () => {
    if (wartet) return;
    wartet = true;
    setTimeout(() => { wartet = false; pruefen(); }, 100);
  };
  window.addEventListener('scroll', angestossen, { passive: true });
  window.addEventListener('resize', angestossen, { passive: true });
  pruefen();

  // Ausverkauft/deaktiviert spiegeln
  const spiegeln = () => {
    knopf.disabled = echterButton.disabled;
    knopf.textContent = (echterButton.textContent || '').trim() || 'In den Warenkorb';
  };
  new MutationObserver(spiegeln).observe(echterButton, {
    attributes: true, childList: true, subtree: true
  });
  spiegeln();
})();
